var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assistant-chat" }, [
    _vm.state === "error"
      ? _c("div", { staticClass: "assistant-chat__message" }, [
          _c("p", [_vm._v("The assistant isn't available right now.")]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "assistant-chat__retry", on: { click: _vm.load } },
            [_vm._v("\n      Try again\n    ")]
          )
        ])
      : _vm.state === "loading"
      ? _c("div", { staticClass: "assistant-chat__message" }, [
          _c("p", [_vm._v("Starting the assistant…")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.identity && (_vm.state === "ready" || _vm.view === "history")
      ? _c(
          "button",
          {
            staticClass: "assistant-chat__menu-button",
            attrs: {
              "aria-label": "Assistant menu",
              "aria-haspopup": "menu",
              "aria-expanded": _vm.menuOpen ? "true" : "false"
            },
            on: {
              click: function($event) {
                _vm.menuOpen = !_vm.menuOpen
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "aria-hidden": "true"
                }
              },
              [_c("path", { attrs: { d: "M4 6h16M4 12h16M4 18h16" } })]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.menuOpen
      ? _c(
          "ul",
          { staticClass: "assistant-chat__menu", attrs: { role: "menu" } },
          [
            _c("li", { attrs: { role: "none" } }, [
              _c(
                "button",
                {
                  staticClass: "assistant-chat__menu-item",
                  attrs: { role: "menuitem" },
                  on: {
                    click: function($event) {
                      _vm.menuOpen = false
                      _vm.newChat()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "assistant-chat__menu-title" }, [
                    _vm._v("New chat")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "assistant-chat__menu-desc" }, [
                    _vm._v("Start a fresh conversation")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { attrs: { role: "none" } }, [
              _c(
                "button",
                {
                  staticClass: "assistant-chat__menu-item",
                  attrs: { role: "menuitem" },
                  on: {
                    click: function($event) {
                      _vm.menuOpen = false
                      _vm.showHistory()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "assistant-chat__menu-title" }, [
                    _vm._v("History")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "assistant-chat__menu-desc" }, [
                    _vm._v("View past conversations")
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.view === "history"
      ? _c("div", { staticClass: "assistant-chat__history" }, [
          _c("div", { staticClass: "assistant-chat__history-header" }, [
            _c("div", { staticClass: "assistant-chat__column" }, [
              _c(
                "button",
                {
                  staticClass: "assistant-chat__tool",
                  on: {
                    click: function($event) {
                      _vm.view = "chat"
                    }
                  }
                },
                [_vm._v("\n          ← Back to chat\n        ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "assistant-chat__history-body assistant-chat__column"
            },
            [
              _c(
                "form",
                {
                  staticClass: "assistant-chat__search",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.fetchHistory()
                    }
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    attrs: {
                      type: "search",
                      maxlength: "200",
                      placeholder: "Search conversations"
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.historyState === "error"
                ? _c("p", { staticClass: "assistant-chat__note" }, [
                    _vm._v(
                      "\n        History isn't available right now.\n      "
                    )
                  ])
                : _vm.historyState === "ready" && !_vm.sessions.length
                ? _c("p", { staticClass: "assistant-chat__note" }, [
                    _vm._v("\n        No conversations yet.\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "assistant-chat__sessions" },
                _vm._l(_vm.sessions, function(session) {
                  return _c("li", { key: session.id }, [
                    _c(
                      "button",
                      {
                        staticClass: "assistant-chat__session",
                        on: {
                          click: function($event) {
                            return _vm.openSession(session.id)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "assistant-chat__session-title" },
                          [
                            _vm._v(
                              _vm._s(session.title || "Untitled conversation")
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "assistant-chat__session-when" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatWhen(
                                  session.lastMessageAt || session.updatedAt
                                )
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm.historyState === "loading"
                ? _c("p", { staticClass: "assistant-chat__note" }, [
                    _vm._v("\n        Loading…\n      ")
                  ])
                : _vm.historyState === "ready" && _vm.nextCursor
                ? _c(
                    "button",
                    {
                      staticClass: "assistant-chat__tool assistant-chat__more",
                      on: {
                        click: function($event) {
                          return _vm.fetchHistory(_vm.nextCursor)
                        }
                      }
                    },
                    [_vm._v("\n        Load more\n      ")]
                  )
                : _vm._e()
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.src
      ? _c("iframe", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === "ready" && _vm.view === "chat",
              expression: "state === 'ready' && view === 'chat'"
            }
          ],
          ref: "frame",
          staticClass: "assistant-chat__frame",
          attrs: {
            src: _vm.src,
            title: "Lasso Assistant",
            allow: "microphone; clipboard-write"
          },
          on: {
            load: function($event) {
              _vm.state = "ready"
            }
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }